"use strict";var dd=require("../core");require("../platform"),module.exports=dd;


//////////////////
// WEBPACK FOOTER
// ./~/_dingtalk-jsapi@3.0.14@dingtalk-jsapi/entry/union.js
// module id = 1131
// module chunks = 106